import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { useAuth } from '../../../hooks/useAuth';
import { TransporterIdCard } from '../../../components/TransporterIdCard';
import { transporterList } from '../../../constants/TransportedId';



export const SettingTransporterId: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="py-4 lg:py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <button
            onClick={() => navigate(-1)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Transporter ID</h1>
        </div>

        <div className="flex items-center gap-4 text-gray-600">
          <span className="font-medium">
            {user?.firstName} {user?.lastName}, {user?.email}
          </span>
          <Button variant="link" className="text-primary p-0 h-auto">
            Go to profile
          </Button>
        </div>
      </div>

      {/* Card */}
      <div className="bg-card rounded-[16px] shadow-sm border py-5 px-10">
        <div className="flex flex-col gap-8">
          {/* Section Header */}
          <div className="border-b pb-4">
            <h2 className="text-xl font-semibold mb-2">Transported Id</h2>
            <p className="text-sm text-gray-600">
              For shipments worth ₹50,000 or more, an e-way bill is required.
              Use the courier’s unique transporter ID listed below to generate
              it
            </p>
          </div>

          {/* Transporter Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {transporterList.map((item, index) => (
              <TransporterIdCard
                key={index}
                name={item.name}
                image={item.image}
                transporterId={item.transporterId}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingTransporterId;
